// components/templates/sections/STATS_COFFEE.tsx
import React from "react";
import { useDesign } from "@/context/DesignContext";

type Stat = { value: string; label: string };
type StatsProps = { stats?: Stat[] | string; design?: any };

export default function STATS_COFFEE({ stats = [], design: propDesign }: StatsProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;
  const statsArray = Array.isArray(stats) ? stats : [];
  if (statsArray.length === 0) return null;

  const primaryColor = design?.colors?.primary || "#C8622A";
  const labelColor = design?.colors?.textLight || "#BFA76A";
  const containerMaxWidth = design?.spacing?.containerMaxWidth || "1280px";

  return (
    <section className="py-24 mx-auto px-8" style={{ maxWidth: containerMaxWidth }}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {statsArray.map((s, i) => (
          <div key={s.label} className="text-center group">
            <div className="font-display text-5xl font-black mb-2 group-hover:scale-110 transition-transform duration-300"
                 style={{ color: primaryColor }}>
              {s.value}
            </div>
            <div className="font-mono-custom text-xs tracking-widest uppercase" style={{ color: `${labelColor}99` }}>
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}